import * as types from '../actions/types'
import createReducer from '../createReducer'
import _uniqby from 'lodash.uniqby'

const initialCvUsersState = {
  lastUpdatedUsers: '',
  isFetchingUsers: false,
  fetchUsersSuccess: false,
  fetchUsersFailure: false,
  fetchUsersError: null,
  users: [],
  size: 0,
  page: 0
}

export default createReducer(initialCvUsersState, {
  // USERS
  [types.FETCH_USERS_REQUEST](state, action) {
    return Object.assign({}, state, {
      isFetchingUsers: true,
      fetchUsersSuccess: false,
      fetchUsersFailure: false,
      fetchUsersError: null,
    })
  },
  [types.FETCH_USERS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      isFetchingUsers: false,
      fetchUsersSuccess: true,
      fetchUsersFailure: false,
      fetchUsersError: null,
      users: action.isInfiniteScroll
        ? _uniqby(state.users.concat(action.users), 'id')
        : action.users,
      lastUpdatedUsers: Date.now(),
      size: action.size,
      page: action.page || 0
    })
  },
  [types.FETCH_USERS_FAILURE](state, action) {
    return Object.assign({}, state, {
      isFetchingUsers: false,
      fetchUsersSuccess: false,
      fetchUsersFailure: true,
      fetchUsersError: action.error,
    })
  },
})
